import lobo from "./lobo_pl_cropped.png";
import { Link, NavLink } from 'react-router';
import { useState } from 'react';

function NavBar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);
    const showPageContent = () => {
        closeMenu();
        window.setTimeout(() => {
            document.getElementById('page-content')?.scrollIntoView?.({
                behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            });
        }, 0);
    };

    return (
        <header className="mainNav">
            <nav className="navShell" aria-label="Main navigation">
                <Link className="brand" to="/" onClick={closeMenu} aria-label="Lobo Powerlifting home">
                    <span className="brand__mark">
                        <img src={lobo} alt="" />
                    </span>
                    <span className="brand__name">
                        <strong>Lobo</strong>
                        <span>Powerlifting</span>
                    </span>
                </Link>

                <button
                    className={`menuToggle${menuOpen ? ' is-open' : ''}`}
                    type="button"
                    aria-expanded={menuOpen}
                    aria-controls="navLinks"
                    aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span />
                    <span />
                </button>

                <div className={`navLinks${menuOpen ? ' is-open' : ''}`} id="navLinks">
                    <NavLink to="/" end onClick={showPageContent}>Home</NavLink>
                    <NavLink to="/join" onClick={showPageContent}>Join</NavLink>
                    <NavLink to="/contact" onClick={showPageContent}>Contact</NavLink>
                    <NavLink className="navLinks__support" to="/support" onClick={showPageContent}>Support Us</NavLink>
                </div>
            </nav>
        </header>
    );
}

export default NavBar;
